import { InputForm, Error, SelectForm } from "components";
import {
  DcddUserInput,
  DcddUserInputError,
  GenericProps,
} from "../../../state/actionType";

interface Formprops {
  formData: DcddUserInput;
  error: DcddUserInputError;
  dzongkhagData: GenericProps[];
  schoolData: GenericProps[];
  gradeData: GenericProps[];
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
}

const StudenForm: React.FC<Formprops> = ({
  handleChange,
  formData,
  error,
  dzongkhagData,
  schoolData,
  gradeData,
}) => {
  return (
    <div className="grid grid-cols-2 gap-2">
      <div>
        <InputForm
          type="date"
          label="Data of Birth"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
        />
        {error.dob && <Error>{error.dob}</Error>}
      </div>
      <div>
        <SelectForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="Dzongkhag"
          id="dzongkhag_id"
          name="dzongkhag_id"
          value={formData.dzongkhag_id}
          option={dzongkhagData?.map((dzongkhag: GenericProps) => (
            <option
              key={dzongkhag.id.toString()}
              value={dzongkhag.id.toString()}
            >
              {dzongkhag.name}
            </option>
          ))}
          onChange={handleChange}
        />
        {error.dzongkhag_id && <Error>{error.dzongkhag_id}</Error>}
      </div>
      <div>
        <SelectForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="School"
          id="school_id"
          name="school_id"
          value={formData.school_id}
          option={schoolData?.map((school: GenericProps) => (
            <option key={school.id.toString()} value={school.id.toString()}>
              {school.name}
            </option>
          ))}
          onChange={handleChange}
        />
        {error.school_id && <Error>{error.school_id}</Error>}
      </div>
      <div>
        <SelectForm
          type="text"
          styleLabel="text-sm/6 font-medium after:content-['*'] after:ml-1 after:text-red-500"
          label="Grade"
          id="grade_id"
          name="grade_id"
          value={formData.grade_id}
          option={gradeData?.map((grade: GenericProps) => (
            <option key={grade.id.toString()} value={grade.id.toString()}>
              {grade.name}
            </option>
          ))}
          onChange={handleChange}
        />
        {error.grade_id && <Error>{error.grade_id}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          label="CID"
          id="cid"
          name="cid"
          value={formData.cid}
          onChange={handleChange}
        />
      </div>
      <div>
        <InputForm
          type="text"
          label="Studen ID"
          id="student_id"
          name="student_id"
          value={formData.student_id}
          onChange={handleChange}
        />
        {error.student_id && <Error>{error.student_id}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          label="Email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        {error.email && <Error>{error.email}</Error>}
      </div>
      <div>
        <InputForm
          type="text"
          label="Mobile No."
          id="mobile_no"
          name="mobile_no"
          value={formData.mobile_no}
          onChange={handleChange}
        />
        {error.mobile_no && <Error>{error.mobile_no}</Error>}
      </div>
    </div>
  );
};

export default StudenForm;
